import { SetPasswordError } from '@pages/set-password/models/set-password-error.enum';

export const setPasswordErrorMessages: Partial<Record<SetPasswordError, string>> = {
  [SetPasswordError.PasswordMinimumRequiredLength]: 'set-password.messages.password-minimum-required-length',
};
